<div *ngIf="multiBuyer" class="multi-buyer-header py-2 w-100">
  <div class="header-content-container">
    <div class="centered-text text-white">
      Logged in as <b class="font-weight-bold">{{ multiBuyer.nm }}</b> Account
    </div>

    <div class="button-aside" *ngIf="!changesNotAllowed">
      <span class="custom-switch-btn" (click)="selectMultiBuyer()">
        Switch Account
      </span>
    </div>
  </div>
</div>
